import { getStoreAccessors } from 'typesafe-vuex';
import { AdminState } from '../state';
import { State } from '@/store/state';
import { actions } from '../actions';

const { dispatch } = getStoreAccessors<AdminState, State>('');

export const dispatchCreateUser = dispatch(actions.actionCreateUser);
export const dispatchGetUsers = dispatch(actions.actionGetUsers);
export const dispatchGetUser = dispatch(actions.actionGetUser);
export const dispatchUpdateUser = dispatch(actions.actionUpdateUser);
export const dispatchDeleteUser = dispatch(actions.actionDeleteUser);
export const dispatchDeleteUsers = dispatch(actions.actionDeleteUsers);

export const dispatchGetContracts = dispatch(actions.actionGetContracts);

export const dispatchCreateService = dispatch(actions.actionCreateService);
export const dispatchGetServices = dispatch(actions.actionGetServices);
export const dispatchGetService = dispatch(actions.actionGetService);
export const dispatchUpdateService = dispatch(actions.actionUpdateService);
export const dispatchDeleteService = dispatch(actions.actionDeleteService);
export const dispatchDeleteServices = dispatch(actions.actionDeleteServices);

export const dispatchCreateSender = dispatch(actions.actionCreateSender);
export const dispatchGetSenders = dispatch(actions.actionGetSenders);
export const dispatchGetSender = dispatch(actions.actionGetSender);
export const dispatchUpdateSender = dispatch(actions.actionUpdateSender);
export const dispatchDeleteSender = dispatch(actions.actionDeleteSender);
export const dispatchDeleteSenders = dispatch(actions.actionDeleteSenders);

export const dispatchCreateTemplate = dispatch(actions.actionCreateTemplate);
export const dispatchGetTemplates = dispatch(actions.actionGetTemplates);
export const dispatchGetTemplate = dispatch(actions.actionGetTemplate);
export const dispatchUpdateTemplate = dispatch(actions.actionUpdateTemplate);
export const dispatchDeleteTemplate = dispatch(actions.actionDeleteTemplate);
export const dispatchDeleteTemplates = dispatch(actions.actionDeleteTemplates);

export const dispatchCreateProxyError = dispatch(actions.actionCreateProxyError);
export const dispatchGetProxyErrors = dispatch(actions.actionGetProxyErrors);
export const dispatchGetProxyError = dispatch(actions.actionGetProxyError);
export const dispatchUpdateProxyError = dispatch(actions.actionUpdateProxyError);
export const dispatchDeleteProxyError = dispatch(actions.actionDeleteProxyError);
export const dispatchDeleteProxyErrors = dispatch(actions.actionDeleteProxyErrors);

export const dispatchCreateProxyUserBan = dispatch(actions.actionCreateProxyUserBan);
export const dispatchGetProxyUserBans = dispatch(actions.actionGetProxyUserBans);
export const dispatchDeleteProxyUserBan = dispatch(actions.actionDeleteProxyUserBan);
export const dispatchDeleteProxyUserBans = dispatch(actions.actionDeleteProxyUserBans);
export const dispatchGetProxyUserBansStatistics = dispatch(actions.actionGetProxyUserBansStatistics);

export const dispatchParseMessage = dispatch(actions.actionParseMessage);

export const dispatchGetPriorities = dispatch(actions.actionGetPriorities);
export const dispatchUpdatePriority = dispatch(actions.actionUpdatePriority);

export const dispatchGetMNOs = dispatch(actions.actionGetMNOs);
export const dispatchGetMNO = dispatch(actions.actionGetMNO);
export const dispatchUpdateMNO = dispatch(actions.actionUpdateMNO);
export const dispatchCreateMNO = dispatch(actions.actionCreateMNO);
export const dispatchDeleteMNO = dispatch(actions.actionDeleteMNO);

export const dispatchCheckTemplateProxy = dispatch(actions.actionCheckTemplateProxy);
export const dispatchCheckMNOMask = dispatch(actions.actionCheckMNOMask);
export const dispatchAddMNOMask = dispatch(actions.actionAddMNOMask);
export const dispatchDeleteMNOMasks = dispatch(actions.actionDeleteMNOMasks);
export const dispatchGetMNOMasks = dispatch(actions.actionGetMNOMasks);

export const dispatchCreateMNOSender = dispatch(actions.actionCreateMNOSender);
export const dispatchUpdateMNOSender = dispatch(actions.actionUpdateMNOSender);
export const dispatchDeleteMNOSenders = dispatch(actions.actionDeleteMNOSenders);
export const dispatchGetMNOSenders = dispatch(actions.actionGetMNOSenders);

export const dispatchCreateServiceBanPolicy = dispatch(actions.actionCreateServiceBanPolicy);
export const dispatchGetServiceBanPolicies = dispatch(actions.actionGetServiceBanPolicies);
export const dispatchGetServiceBanPolicy = dispatch(actions.actionGetServiceBanPolicy);
export const dispatchUpdateServiceBanPolicy = dispatch(actions.actionUpdateServiceBanPolicy);
export const dispatchDeleteServiceBanPolicy = dispatch(actions.actionDeleteServiceBanPolicy);
export const dispatchDeleteServiceBanPolicies = dispatch(actions.actionDeleteServiceBanPolicies);

export const dispatchGetTags = dispatch(actions.actionGetTags);
export const dispatchSuggestTags = dispatch(actions.actionSuggestTags);
